/**
 * The token meter's figures in the UI language, with Western digits in every language, as the
 * catalogs keep them (`src/test/__tests__/locale-parity.test.ts`).
 */

/** A token count, short: "151.2K", "1M". */
export function tokenCount(tokens: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    notation: 'compact',
    maximumFractionDigits: 1,
    numberingSystem: 'latn',
  }).format(tokens);
}

/**
 * The share of the window used, as a whole percent in the language's own form; a share above 0
 * that rounds to 0 reads "<" and that form's 1 %.
 */
export function sharePercent(used: number, window: number, locale: string): string {
  const percent = new Intl.NumberFormat(locale, { style: 'percent', numberingSystem: 'latn' });
  const share = used / window;
  const rounded = Math.round(share * 100) / 100;
  return share > 0 && rounded === 0 ? `<${percent.format(0.01)}` : percent.format(rounded);
}

/** The share the ring and the bar draw: at least 4 % of a share above 0, and never more than all. */
export function drawnShare(used: number, window: number): number {
  const share = used / window;
  return share > 0 ? Math.min(1, Math.max(0.04, share)) : 0;
}
